import { useNavigate, useParams } from 'react-router-dom'

import { TrainingClassFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

interface SelectedItem {
  item: unknown
  checked: boolean
}

interface BulkActionParams {
  itemsStatus: readonly SelectedItem[]
}

export const useBulkAction = (trainingClasses: TrainingClassFragment[]) => {
  const { id } = useParams()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (action: string, selectedRows: BulkActionParams) => {
    if (action === 'delete-all') {
      const membershipIds = [...selectedRows.itemsStatus]
        .filter((status) => status.checked)
        .map((status) => {
          const item = status.item
          if (item && typeof item === 'object' && 'id' in item && typeof item.id === 'number') {
            return item.id
          }
          return null
        })
        .filter((membershipId): membershipId is number => membershipId !== null)

      navigate(
        navigation.trainings.list.details_revamp.view.participants.deleteParticipants.fullPath({
          id: Number(id),
        }),
        { state: { membershipIds } }
      )
    } else if (action === 'assign-to-group') {
      const emptyClasses = trainingClasses.length === 0

      const selectedAccessIds = [...selectedRows.itemsStatus]
        .filter((status) => status.checked)
        .map((status) => {
          const item = status.item
          if (
            item &&
            typeof item === 'object' &&
            'accessId' in item &&
            typeof item.accessId === 'number'
          ) {
            return item.accessId
          }
          return null
        })
        .filter((accessId): accessId is number => accessId !== null)

      const assignToGroupPath = emptyClasses
        ? navigation.trainings.list.details_revamp.view.trainingClasses.tab.newClass.fullPath({
            id: Number(id),
          })
        : navigation.trainings.list.details_revamp.view.participants.assignParticipants.fullPath({
            id: Number(id),
          })
      navigate(assignToGroupPath, { state: { selectedAccessIds } })
    }
  }
}
